// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RCSc","type":"styles_type__2qCYs","choices":"styles_choices__1mD7u"};